module.exports = __webpack_public_path__ + "src/assets/img/glasses.fd8e1c2b3c403e01533853388ce30d87.svg";